/**
 * Common utility functions
 * Most auth functionality has been migrated to RTK Query and Redux
 * Only keeping getToken for backward compatibility with apiClient
 */

// Return the token from sessionStorage
// This is the ONLY auth-related storage access that should remain
// Used by apiClient for Authorization header
// Token expires when browser closes for HIPAA compliance
export const getToken = () => {
  return sessionStorage.getItem('token') || null;
}

// Legacy functions below are deprecated and will be removed
// DO NOT USE - Use RTK Query and Redux instead

// @deprecated - Use usePermissions hook instead
export const getUser = () => {
  console.warn('getUser() is deprecated. Use usePermissions hook instead.');
  return null;
}

// @deprecated - Use RTK Query logout mutation instead
export const removeUserSession = () => {
  console.warn('removeUserSession() is deprecated. Use RTK Query logout mutation instead.');
}

// @deprecated - RTK Query handles this automatically
export const setUserSession = (token, user) => {
  console.warn('setUserSession() is deprecated. RTK Query handles auth automatically.');
}